module.exports = __webpack_public_path__ + "img/ICON_revoke_consent.df592e85.jpg";